import { render, staticRenderFns } from "./ModelShow.vue?vue&type=template&id=a684e426&scoped=true&"
import script from "./ModelShow.vue?vue&type=script&lang=js&"
export * from "./ModelShow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/components/ModelShow.css?vue&type=style&index=0&id=a684e426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a684e426",
  null
  
)

export default component.exports